"use client";

import { createContext, useContext } from "react";

import type { Region } from "./region";
import { regionSwitchHref, type RegionPaths } from "./region-switch";
import { usePublicPathname } from "@/lib/public-pathname";

const RegionPathsContext = createContext<RegionPaths>({ ie: [], uk: [] });

export function RegionPathsProvider({
  paths,
  children,
}: {
  paths: RegionPaths;
  children: React.ReactNode;
}) {
  return <RegionPathsContext.Provider value={paths}>{children}</RegionPathsContext.Provider>;
}

export function useRegionSwitchHrefs(): Record<Region, string> {
  const paths = useContext(RegionPathsContext);
  const pathname = usePublicPathname() ?? "/";
  return {
    ie: regionSwitchHref("ie", pathname, paths),
    uk: regionSwitchHref("uk", pathname, paths),
  };
}
